import styled, { css } from 'styled-components'
import React from 'react'
import { TextLink, Div } from 'konsys-ui'
import { Modal, Alert } from 'antd'
import { theme } from '../../styles/_variables'

export const DividerStyled = styled.hr`
  border: none;
  border-top: 1px solid ${props => props.color || theme.color.veryLightBlue};
  margin: ${props => props.margin || '16px 0'};
`

export const TagWrapper = styled.div`
  cursor: pointer;
  display: inline-block;
  border-radius: 30px;
  padding: 2px 8px;
  background-color: ${theme.color.veryLightBlue};
  ${props => props.margin && css`
    margin: ${props.margin};
  `}
`

export const SummaryCardWrapper = styled.div`
  background-color: ${theme.color.offWhite};
  border-radius: 4px;
  box-shadow: 0 0 3px ${theme.color.paleGrey};
  padding: 24px;
`

export const CollapseContentWrapper = styled.div`
  min-height: 0px;
  height: 0;
  transition: min-height ${theme.animate.time.maxHeight} ease-in-out;
  overflow: hidden;
  margin: 16px;
`

export const CollapseWrapper = styled(props => <Div {...props} />)`
  > div {
    > i {
      transition: ${theme.animate.transition};
    }
  }
  ${props => props.open && css`
    > div {
      > i {
        transform: rotate(-180deg);
      }
    }
    ${CollapseContentWrapper} {
      min-height: ${props.minHeight};
      overflow: auto;
    }
    ${props.fullHeight && css`
      ${CollapseContentWrapper} {
        height: auto;
        overflow: hidden;
      }
    `}
  `}
`

export const CardListWrapper = styled(props => <Div {...props} />)`
  background-color: ${theme.color.offWhite};
  padding: 16px;
  border-bottom: 1px solid ${theme.color.veryLightBlue};
  cursor: pointer;
  ${props => props.active && css`
    background-color: ${theme.color.veryLightBlue};
  `}
`

export const CardListHeaderWrapper = styled(props => <Div {...props} />)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CardListContentWrapper = styled(props => <Div {...props} />)`
  display: flex;
  align-items: flex-start;
  margin: 16px 0 0;
  > div {
    &:first-child {
      flex-basis: ${props => (props.fullWidth ? '100%' : '65%')};
    }
  }
`

export const ListWrapper = styled(props => <Div {...props} />)`
  > ${CardListWrapper} {
    &:last-child {
      border-bottom: 0;
    }
  }
`

export const TabHeaderWrapper = styled(props => <Div {...props} />)`
  border-bottom: 1px solid ${theme.color.veryLightBlue};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TabContentWrapper = styled(props => <Div {...props} />)`
  padding: 16px 16px 0;
  height: calc(100vh - 172px);
  overflow: auto;
  ${props => props.fullHeight && css`
    height: calc(100vh - 118px);
  `}
  ${props => props.filterHeight && css`
    height: calc(100vh - (172px + ${props.filterHeight}px));
  `}
`

export const TabWrapper = styled(props => <Div {...props} />)`
  background-color: ${props => (props.white ? theme.color.offWhite : theme.color.paleBlue)};
  width: 100%;
`

export const TabTitleWrapper = styled(props => <Div {...props} />)`
  display: inline-block;
  padding: 8px 16px;
  span {
    cursor: pointer;
  }
  ${props => props.active && css`
    background-color: ${theme.color.secondaryColor};
  `}
`

export const ModalCustomized = styled(Modal)`
  .ant-modal-header {
    border-style: none;
    padding: 24px 24px !important;
    .ant-modal-title {
      font-size: 22px;
    }
  }
  .ant-modal-footer {
    border-style: none;
    padding: 24px 24px !important;
    padding-top: 0 !important;
  }
  .ant-modal-body {
    padding-bottom: 8px !important;
  }
`

export const AlertCustomized = styled(Alert)`
  background-color: ${theme.color.remark};
  border: none;
  .ant-alert-message {
    font-weight: ${theme.fonts.style.regular};
    font-size: ${theme.fonts.size.small};
    margin: 0;
    color: ${theme.color.black};
  }
  .ant-alert-description {
    font-size: ${theme.fonts.size.normal};
    color: ${theme.color.black};
  }
  .ant-alert-icon {
    color: #faad14;
  }
`

export const PreviewImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  object-position: center;
  border-radius: 5px;
  margin: 5px 16px 5px 0;
  &:hover {
    cursor: pointer;
  }
`

export const RowSelectChildWrapper = styled(props => <Div {...props} />)`
  ${props => props.header && css`
    background-color: ${theme.color.veryLightBlue};
  `}
  > div {
    &:last-child {
      border: 0;
    }
  }
`

export default DividerStyled
